<template>
  <div class="space-y-6">
    <!-- Avatar -->
    <div>
      <div class="mb-3 flex items-center gap-1.5 text-sm font-semibold text-gray-700 dark:text-gray-200">
        <ImageIcon class="w-4 h-4 text-primary" aria-hidden="true" />
        {{ t('shell.account.tabAvatar') }}
      </div>
      <AccountAvatarTab :current-avatar="avatar" @updated="emit('update:avatar', $event)" />
    </div>

    <!-- Username -->
    <div class="border-t border-gray-100 dark:border-gray-700/50 pt-6">
      <div class="mb-3 flex items-center gap-1.5 text-sm font-semibold text-gray-700 dark:text-gray-200">
        <AtSign class="w-4 h-4 text-primary" aria-hidden="true" />
        {{ t('shell.account.tabUsername') }}
      </div>
      <AccountUsernameTab :current-username="username" @updated="emit('update:username', $event)" />
    </div>

    <!-- Email -->
    <div class="border-t border-gray-100 dark:border-gray-700/50 pt-6">
      <div class="mb-3 flex items-center gap-1.5 text-sm font-semibold text-gray-700 dark:text-gray-200">
        <Mail class="w-4 h-4 text-primary" aria-hidden="true" />
        {{ t('shell.account.tabEmail') }}
      </div>
      <AccountEmailTab :current-email="email" @updated="emit('update:email', $event)" />
    </div>

    <!-- Phone：仅在后台开启「注册需填写手机号」时展示 -->
    <div v-if="phoneEnabled" class="border-t border-gray-100 dark:border-gray-700/50 pt-6">
      <div class="mb-3 flex items-center gap-1.5 text-sm font-semibold text-gray-700 dark:text-gray-200">
        <Phone class="w-4 h-4 text-primary" aria-hidden="true" />
        {{ t('shell.account.tabPhone') }}
      </div>
      <AccountPhoneTab :current-phone="phone" @updated="emit('update:phone', $event)" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { AtSign, ImageIcon, Mail, Phone } from 'lucide-vue-next'
import { useI18n } from '../../composables/useI18n'
import AccountAvatarTab from './AccountAvatarTab.vue'
import AccountEmailTab from './AccountEmailTab.vue'
import AccountPhoneTab from './AccountPhoneTab.vue'
import AccountUsernameTab from './AccountUsernameTab.vue'

withDefaults(
  defineProps<{
    username: string
    email: string
    phone: string
    avatar: string
    /** 后台是否开启手机号相关功能，关闭时不展示「修改手机号」 */
    phoneEnabled?: boolean
  }>(),
  { phoneEnabled: false },
)
const emit = defineEmits<{
  'update:username': [value: string]
  'update:email': [value: string]
  'update:phone': [value: string]
  'update:avatar': [value: string]
}>()

const { t } = useI18n()
</script>
